import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { SWRConfig } from 'swr';
import { notifyError } from '../utils/bugsnag';
import az from './locales/az.json';
import ru from './locales/ru.json';
import { GlobalStyles } from '../sharedNewEditAdPage/styles';
import { buildProfileFallback } from '../sharedNewEditAdPage/api/profileFallback';

document.addEventListener('DOMContentLoaded', async () => {
  const container = document.getElementById('new-ad-app');
  if (container) {
    try {
      const [{ createRoot }, { ContextWrapper }, { customizeI18n }, { Content }] =
        await Promise.all([
          import('react-dom/client'),
          import('./context/ContextWrapper'),
          import('../utils/i18n'),
          import('./components/Content')
        ]);
      const i18n = customizeI18n({ az, ru });
      const dataset = JSON.parse(JSON.stringify(container.dataset));
      const fallback = buildProfileFallback(dataset.profile);

      createRoot(container).render(
        <I18nextProvider {...{ i18n }}>
          <SWRConfig value={{ fallback }}>
            <ContextWrapper {...{ dataset }}>
              <GlobalStyles />
              <Content />
            </ContextWrapper>
          </SWRConfig>
        </I18nextProvider>
      );
    } catch (error) {
      console.error('Error initializing new-ad-app:', error);
      notifyError(error);
    }
  }
});
